




























import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import DynamicForm from '@/components/shared/DynamicForm.vue';
import { WorkflowKanbanPopupFieldsHelper, confirmationHelper } from '@/mixins';
import { WorkflowKanbanJobProcessResultStatus, WorkflowKanbanPopupFieldsStatus } from '@/types';
import { WorkflowKanbanService } from '@/services';

export default Vue.extend({
  name: 'WorkflowKanbanPopupFields',
  data() {
    return {
      formInvalidFeedback: '',
      isSubmitting: false
    };
  },
  mixins: [WorkflowKanbanPopupFieldsHelper, confirmationHelper],
  methods: {
    ...mapActions('workflowKanbanJobStore', ['setPopupFieldsSchema', 'setPopupFieldsStatus']),
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    resetFormInvalidFeedback() {
      this.formInvalidFeedback = '';
    },
    setFormInvalidFeedback(feedback: string) {
      this.formInvalidFeedback = feedback;
    },
    async onCancel(this: any, dirty: boolean) {
      const confirmed = await this.haveConfirmationToLoseUnsavedChangesAsync(dirty);
      if (!confirmed) {
        return;
      }
      this.closeModal();
      this.setApplicationDirty(false);
      this.setPopupFieldsStatus(WorkflowKanbanPopupFieldsStatus.ProcessCancelled);
    },
    async haveConfirmationToLoseUnsavedChangesAsync(this: any, dirty: boolean): Promise<boolean> {
      if (!dirty) {
        return true;
      }
      try {
        return !(await this.hasUnsavedChangesToKeepAsync(this.$bvModal, true));
      } catch (error) {
        this.$log('failed to confirm unsaved changes');
        return false;
      }
    },
    async onProcess(this: any) {
      this.isSubmitting = true;
      this.resetFormInvalidFeedback();
      this.setPopupFieldsStatus(WorkflowKanbanPopupFieldsStatus.Processing);
      try {
        const response = await WorkflowKanbanService.processCardAsync(
          this.getQueueId,
          this.getJobId,
          this.getTargetLane,
          this.getReadTime,
          this.getPopupFieldDataSources
        );

        switch (parseInt(response.workflowKanbanJobProcessResultStatus, 10)) {
          case WorkflowKanbanJobProcessResultStatus.UnableToAcquireLock: {
            const message = response.workflowJobProcessResult.message;
            this.setFormInvalidFeedback(message);
            break;
          }
          case WorkflowKanbanJobProcessResultStatus.ProcessSuccessful: {
            this.closeModal();
            this.setApplicationDirty(false);
            this.setPopupFieldsStatus(WorkflowKanbanPopupFieldsStatus.ProcessSuccessful);
          }
        }
      } catch (error) {
        this.setFormInvalidFeedback(error.notification);
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  computed: {
    ...mapGetters('workflowKanbanJobStore', [
      'getPopupFieldSchema',
      'getPopupFieldDataSources',
      'getQueueId',
      'getJobId',
      'getSourceLane',
      'getTargetLane',
      'getReadTime',
      'getCanProcess'
    ]),
    popupFieldSchemas: {
      get(this: any) {
        return this.getPopupFieldSchema;
      },
      set(this: any, value: any) {
        this.setPopupFieldsSchema(value);
      }
    },
    title(this: any) {
      return `${this.getSourceLane} to ${this.getTargetLane}`;
    }
  },
  mounted() {
    this.setPopupFieldsStatus(WorkflowKanbanPopupFieldsStatus.Displayed);
  },
  components: {
    DynamicForm
  }
});
